import React from "react";
import * as palette from "@govlaunch/palette";

const SectionHeader: React.FunctionComponent = ({ children }) => {
  return (
    <div
      css={{
        borderBottom: `1px solid ${palette.lightestGray}`,
        padding: 16,
        textTransform: "uppercase",
        fontSize: 12,
        color: palette.darkGray,
        letterSpacing: 0.5,
        fontWeight: 500,
      }}
    >
      {children}
    </div>
  );
};

export default SectionHeader;
